import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryDto, SearchCountriesParams } from '../interfaces/countries';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private iContactURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iContactURL = config.apiContactAdminBaseUrl;
  }

  fetchCountries(searchCountriesParams?: SearchCountriesParams): Observable<CountryDto[]> {
    return this.http.get<CountryDto[]>(`${this.iContactURL}/Global/pays`, {
      params: searchCountriesParams ? { ...searchCountriesParams } : {},
    });
  }
}
